// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AtcBall_wrapper__11-eT"};